import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { internalTokens } from "./themes3.js";
function Text({
  children
}) {
  return /* @__PURE__ */ jsx(StyledText, {
    children
  });
}
const StyledText = styled.div.withConfig({
  displayName: "StyledText",
  componentId: "sc-1gzvsli-0"
})(["", " padding-block:", ";color:", ";"], textStyles.paragraphS, token.spacing3, internalTokens["tooltip-text-color"]);
export {
  StyledText,
  Text
};
//# sourceMappingURL=Text4.js.map
